import {
	Component,
	OnInit,
	ViewChild,
	ElementRef
} from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
	moduleId: module.id,
	selector: 'spinner-component',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent implements OnInit {
	bIsActive: boolean;
	nType: number;
	@ViewChild('spinner') spinner: ElementRef;

	constructor (spinner: SpinnerService) {
		spinner.status.subscribe((result: Object) => {
			this.bIsActive = (result as any).status;
			this.nType = (result as any).type;
		});
	}

	ngOnInit() {
		this.setLoadGiftStyle();
	}

	setLoadGiftStyle(count: number=0) {
		if(count > 50) {
			console.log('Fail to load the loading gift');
		} else if(!this.spinner) {
			count ++;
			setTimeout(() => this.setLoadGiftStyle(count), 50);
		} else {
			let strLeft = '';
			let strTop = '';
			if(this.nType === 0) {
				strLeft = '-25px';
				strTop = '-25px';
			} else {
				strLeft = '-100px';
				strTop = '-25px';
			}

			this.spinner.nativeElement.style.marginLeft = strLeft;
			this.spinner.nativeElement.style.margintop = strTop;
		}
	}
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/spinner/spinner.component.ts